import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Navigate,
  Route,
  Link as RouterLink,
  Routes,
  useLocation,
} from "react-router-dom";
import BrandsMetadataTasksTable from "../../components/Brand/Reports/BrandsMetadataTasksTable";
import BrandsPlacesTasksTable from "../../components/Brand/Reports/BrandsPlacesTasksTable";
import TasksStatsTable from "../../components/Brand/Reports/TasksStatsTable";

const DataOpsTasksPage: React.FC<{}> = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [selectedTabName, setSelectedTabName] = useState<string>("");

  const tabs = [
    { name: "Metadata Tasks", path: "metadata_tasks" },
    { name: "Places Review", path: "places_review" },
    { name: "Task Stats", path: "task_stats" },
  ];

  useEffect(() => {
    const currentTabIndex = tabs.findIndex((tab) =>
      location.pathname.endsWith(tab.path.split("/").pop() || "")
    );
    setSelectedTab(currentTabIndex === -1 ? 0 : currentTabIndex);
    setSelectedTabName(
      currentTabIndex === -1 ? tabs[0].name : tabs[currentTabIndex].name
    );
  }, [location.pathname]);

  useEffect(() => {
    document.title = `DataOps Tasks - ${selectedTabName}`;
  }, [selectedTabName]);

  return (
    <Box>
      <h1>DataOps Tasks</h1>

      {/* Tabs navigation */}
      <Tabs
        value={selectedTab}
        onChange={(e, newValue) => setSelectedTab(newValue)}
        sx={{ marginBottom: 2 }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.path}
            label={tab.name}
            component={RouterLink}
            to={tab.path}
          />
        ))}
      </Tabs>

      {/* Routes to render content */}
      <Routes>
        <Route path="/" element={<Navigate to="metadata_tasks" replace />} />
        <Route path="metadata_tasks" element={<BrandsMetadataTasksTable />} />
        <Route path="places_review" element={<BrandsPlacesTasksTable />} />
        <Route path="task_stats" element={<TasksStatsTable />} />
      </Routes>
    </Box>
  );
};

export default DataOpsTasksPage;
